import { Card } from '@/components/ui/card'
import { Database, CheckCircle2, CloudDownload } from 'lucide-react'

interface BackupIntelligenceProps {
  data: {
    successRate: number
    rpoStatus: string
    totalDataProtected: string
    jobs: { id: string; name: string; status: string; timestamp: string }[]
  }
}

export function BackupIntelligence({ data }: BackupIntelligenceProps) {
  return (
    <Card className="p-6 bg-slate-900/50 border-slate-800 backdrop-blur-md">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h3 className="text-lg font-bold text-white flex items-center gap-2">
            <Database className="size-4 text-emerald-500" /> Backup Integrity
          </h3>
          <p className="text-xs text-slate-500 mt-1">RPO: {data.rpoStatus.toUpperCase()}</p>
        </div>
        <div className="text-right">
          <span className="text-xl font-bold text-white font-mono">{data.successRate}%</span>
          <p className="text-[10px] text-slate-500 uppercase font-bold tracking-widest">
            Success Rate
          </p>
        </div>
      </div>
      <div className="mb-8 space-y-4">
        <div className="flex justify-between items-end mb-2">
          <span className="text-xs font-bold text-slate-400 uppercase tracking-widest">
            Protected Volume
          </span>
          <span className="text-xs font-mono text-white">{data.totalDataProtected}</span>
        </div>
        <div className="w-full bg-slate-800 rounded-full h-1">
          <div
            className="h-1 rounded-full bg-emerald-500 transition-all duration-1000"
            style={{ width: '85%' }}
          />
        </div>
      </div>
      <div className="space-y-4">
        <h4 className="text-[10px] font-bold text-slate-600 uppercase tracking-widest">
          Live Sync Queue
        </h4>
        {data.jobs.map((job) => (
          <div
            key={job.id}
            className="flex items-center justify-between border-b border-slate-800 pb-3 last:border-0"
          >
            <div className="flex items-center gap-3">
              {job.status === 'completed' ? (
                <CheckCircle2 className="size-3 text-emerald-500" />
              ) : (
                <CloudDownload className="size-3 text-blue-500 animate-bounce" />
              )}
              <span className="text-xs font-medium text-slate-300">{job.name}</span>
            </div>
            <span className="text-[10px] font-mono text-slate-500">
              {new Date(job.timestamp).toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
              })}
            </span>
          </div>
        ))}
      </div>
    </Card>
  )
}
